import { createFileRoute } from '@tanstack/react-router';
import AdminGames from '../../pages/admin/Games';
import { gamesQueryOptions, playersQueryOptions, prismicMatchesQueryOptions } from '../../lib/queryOptions';

export const Route = createFileRoute('/admin/')({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(gamesQueryOptions()),
      // Games.tsx gebruikt de spelers voor het wedstrijdformulier
      queryClient.ensureQueryData(playersQueryOptions()),
      // prefetch gooit niet: als Prismic onbereikbaar is, laadt de pagina gewoon
      queryClient.prefetchQuery(prismicMatchesQueryOptions()),
    ]),
  component: AdminGames,
});
